import { memo } from "react";

import {
  FulfillmentGroupStatus,
  isEditingLockedStatus,
} from "@redotech/redo-fulfillment-group-common/fulfillment-group-status";
import {
  isCustomParcel,
  Parcel,
} from "@redotech/redo-fulfillment-parcel-common/parcel";
import TrashIcon from "@redotech/redo-icons/trash-01.svg";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import * as styles from "./parcel-list.module.css";
import { ParcelPackingSlipDownloadButton } from "./parcel-packing-slip-download-button";

export const ParcelList = memo(function ParcelList({
  openModal,
  selectedParcels,
  onRemoveParcel,
  trackingNumbers,
  selectedStatus,
  showParcelPackingSlipButtons,
  fulfillmentGroupId,
}: {
  openModal: () => void;
  selectedParcels: Parcel[];
  onRemoveParcel: (index: number) => void;
  trackingNumbers?: string[];
  selectedStatus: FulfillmentGroupStatus | null | undefined;
  showParcelPackingSlipButtons?: boolean;
  fulfillmentGroupId?: string;
}) {
  return (
    <Flex
      borderColor="primary"
      borderStyle="solid"
      borderWidth="1px"
      dir="column"
      gap="none"
      radius="md"
    >
      {selectedParcels.map((parcel, index) => (
        <Flex
          align="center"
          borderBottomWidth={
            index === selectedParcels.length - 1 ? "none" : "1px"
          }
          borderColor="primary"
          borderStyle="solid"
          className={styles.parcelRow}
          dir="row"
          justify="space-between"
          key={`${parcel._id}-${index}`}
          onClick={openModal}
          p="sm"
        >
          <Flex align="center" dir="row" gap="sm" overflow="hidden">
            <Flex dir="column" gap="xs" overflow="hidden">
              <Flex align="baseline" dir="row" gap="sm">
                <Text fontSize="xs" fontWeight="semibold" overflow="hidden">
                  {parcel.name}
                </Text>
                {isCustomParcel(parcel) && parcel.name === "Custom" && (
                  <Text
                    fontSize="xxs"
                    fontWeight="regular"
                    textColor="tertiary"
                  >
                    {parcel.length}x{parcel.width}x{parcel.height}{" "}
                    {parcel.lengthUnit}, {parcel.weight} {parcel.weightUnit}
                  </Text>
                )}
              </Flex>
              {trackingNumbers?.[index] && (
                <Text fontSize="xs">{`Tracking number: ${trackingNumbers[index]}`}</Text>
              )}
            </Flex>
            {showParcelPackingSlipButtons && fulfillmentGroupId && (
              <ParcelPackingSlipDownloadButton
                fulfillmentGroupId={fulfillmentGroupId}
                parcelIndex={index}
              />
            )}
          </Flex>
          <RedoButton
            aria-label="Delete"
            disabled={isEditingLockedStatus(selectedStatus)}
            hierarchy="tertiary"
            IconLeading={TrashIcon}
            onClick={(e) => {
              e.stopPropagation();
              onRemoveParcel(index);
            }}
            size="sm"
            theme="destructive"
          />
        </Flex>
      ))}
    </Flex>
  );
});
